import { render, staticRenderFns } from "./childuserlist.vue?vue&type=template&id=74640750&scoped=true"
import script from "./childuserlist.vue?vue&type=script&lang=js"
export * from "./childuserlist.vue?vue&type=script&lang=js"
import style0 from "./childuserlist.vue?vue&type=style&index=0&id=74640750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74640750",
  null
  
)

export default component.exports